import { RequestService } from '@tcc-online/request-service';
import Group from '../types/project/360/Group';

const Admin360GroupService = {
    getGroups,
    getGroup,
    createGroup,
    editGroup,
    deleteGroup,
};

const createUrl = (projectId: number, groupId?: string) => {
    let url = `/admin/products/360/projects/${projectId}/groups`;
    if (groupId) {
        url += `/${groupId}`;
    }
    return url;
};

export interface BasePayload {
    projectId: number;
}

async function getGroups(payload: BasePayload) {
    return await RequestService.get<Group[]>(createUrl(payload.projectId));
}

export interface GroupPayload extends BasePayload {
    groupId: string;
}

async function getGroup(payload: GroupPayload) {
    const { projectId, groupId } = payload;
    return await RequestService.get<Group>(createUrl(projectId, groupId));
}

export interface CreatePayload {
    name: string;
    color: string;
    minimalEvaluatorCount: number;
}

async function createGroup(payload: CreatePayload & BasePayload) {
    const { projectId, name, color, minimalEvaluatorCount } = payload;
    return await RequestService.post<CreatePayload, Group>(
        createUrl(projectId),
        { name, color, minimalEvaluatorCount },
    );
}

type EditPayload = Partial<CreatePayload>;

async function editGroup(payload: EditPayload & GroupPayload) {
    const { projectId, groupId, name, color, minimalEvaluatorCount } = payload;
    return await RequestService.patch<EditPayload, Group>(
        createUrl(projectId, groupId),
        {
            name,
            color,
            minimalEvaluatorCount,
        },
    );
}

async function deleteGroup(payload: GroupPayload) {
    const { projectId, groupId } = payload;
    return await RequestService.delete(createUrl(projectId, groupId));
}

export default Admin360GroupService;
